import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
var EVENT_SESSIONS_QUERY_KEY = 'eventSessions';
var eventSessionsKeys = {
  eventSessions: [EVENT_SESSIONS_QUERY_KEY],
  eventSessionDetail: function eventSessionDetail(eventId, sessionId) {
    return [EVENT_SESSIONS_QUERY_KEY, 'eventSessionDetail', String(eventId), String(sessionId)];
  },
  eventSessionsList: function eventSessionsList(eventId, startDate, page) {
    return [EVENT_SESSIONS_QUERY_KEY, 'eventSessionsList', String(eventId), startDate, page].filter(Boolean);
  }
};
export default eventSessionsKeys;